export default __webpack_public_path__ + "static/media/statue-of-liberty-1210001_1920.82f6fdf1.jpg";